import { Link, Outlet, useNavigate } from 'react-router-dom';
import { LogOut, User, CalendarDays } from 'lucide-react';
import { Button } from '@leoclinic/ui';
import { useAuth } from '@leoclinic/hooks';
import { BRAND_COLORS } from '@leoclinic/types';
import { useClinicPortal } from '@/providers/clinic-provider';
import { ClinicLogo } from '@/components/branding/clinic-logo';

export function ClientLayout() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { clinic } = useClinicPortal();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#F6F3EE]">
      <header className="border-b border-[#ECECEC] bg-white">
        <div className="mx-auto max-w-lg px-4 py-4 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-2 min-w-0">
            <ClinicLogo size="sm" />
            <div className="min-w-0">
              <p className="font-semibold text-sm truncate" style={{ color: BRAND_COLORS.greenDark }}>
                {clinic?.name ?? 'Clínica'}
              </p>
              <p className="text-xs text-muted-foreground truncate">{user?.full_name}</p>
            </div>
          </Link>
          <Button variant="ghost" size="sm" onClick={handleSignOut} className="shrink-0">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
        <nav className="mx-auto max-w-lg px-4 pb-3 flex gap-2">
          <Link
            to="/minhas-marcacoes"
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium hover:bg-muted/60"
            style={{ color: BRAND_COLORS.greenDark }}
          >
            <CalendarDays className="h-4 w-4" />
            Marcações
          </Link>
          <Link
            to="/minha-conta"
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium hover:bg-muted/60"
            style={{ color: BRAND_COLORS.greenDark }}
          >
            <User className="h-4 w-4" />
            Conta
          </Link>
        </nav>
      </header>
      <main className="mx-auto max-w-lg p-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
